import BasePage from './BasePage';
import { connect } from 'react-redux';
import configData from "../config.json";
import { setModalContent, setFiltersContent, setSelectedFilters } from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import Filters from '../components/Filters';
import Table from '../components/Table';
import Seeker from '../components/Seeker';
import $ from 'jquery';

class ArticleTypes extends BasePage {

	loadOnConstructor() {
		this.getArticleTypes = this.getArticleTypes.bind(this);
		this.newArticleType = this.newArticleType.bind(this);
		this.deleteClick = this.deleteClick.bind(this);
		this.deleteArticleType = this.deleteArticleType.bind(this);
		this.deleteArticleTypeCallback = this.deleteArticleTypeCallback.bind(this);
		this.clickPaginationCallback = this.clickPaginationCallback.bind(this);
		this.parseArticleTypeResponse = this.parseArticleTypeResponse.bind(this);
		this.showFilters = this.showFilters.bind(this);
		this.filterResults = this.filterResults.bind(this);
		this.excelExport = this.excelExport.bind(this);
		this.changeSeekerContent = this.changeSeekerContent.bind(this);
		this.handleSeekerChange = this.handleSeekerChange.bind(this);
		this.searchCallback = this.searchCallback.bind(this);

		let startDate = new Date();
		let endDate = new Date();
		startDate.setDate(1);
		startDate.setHours(0);
		startDate.setMinutes(0);
		startDate.setSeconds(0);

		endDate.setMonth(endDate.getMonth() + 1);
		endDate.setDate(0);
		endDate.setHours(23);
		endDate.setMinutes(59);
		endDate.setSeconds(59);

		this.state = {
			canOpenFilters: false,
			canCreateArticleType: false,
			startDate,
			endDate
		};

		this.getArticleTypes('interface');
	}

	getArticleTypes(type) {

		const api = this.getApi();
		let apiParams = [
			{ name: 'page', value: this.state.page ? this.state.page : 1 },
			{ name: 'limit', value: configData.rowsPerPage }
		];

		if (this.state.searchParams) {
			apiParams = apiParams.concat(this.state.searchParams);
		}

		if (type === 'interface') {
			api.getArticleTypesInterface(apiParams, this.parseArticleTypeResponse);
		} else if (type === 'download') {
			apiParams.push({ name: 'export_to_file', value: 1 });
			api.downloadArticleTypes(apiParams, this.parseArticleTypeResponse);
		} else {
			api.getArticleTypes(apiParams, this.parseArticleTypeResponse);
		}
	}

	handleSeekerChange(event, previousSearchValue) {

		const api = this.getApi();
		let params = [];

		['name_like', 'lastname_like', 'email_like'].map(p => {
			return params.push({ name: p, value: event.target.value });
		});
		params.push({ name: 'conditions_type', value: 'or' });
		this.changeSeekerContent(params);

		const aditionalParams = [
			{ name: 'page', value: this.state.page ? this.state.page : 1 },
			{ name: 'limit', value: configData.rowsPerPage }
		];

		params = params.concat(aditionalParams);
		if (previousSearchValue !== event.target.value) {
			params = params.map(elem => {
				if (elem.name === 'page') elem.value = 1;
				return elem;
			});
		}

		api.getArticleTypes(params, this.searchCallback);
	}

	changeSeekerContent(newSearchParams) {
		this.setState(prevState => {
			return {
				...prevState,
				searchParams: newSearchParams
			}
		});
	}



	excelExport() {
		this.setState(prevState => {
			return {
				...prevState,
				download: true
			}
		}, this.getArticleTypes.bind(this, 'download'));
	}

	parseArticleTypeResponse(response) {
		if (response.status === 'OK') {

			this.setState(prevState => {
				return {
					...prevState,
					totalItems: response.totalItems,
					totalPages: response.totalPages,
					currentPage: response.currentPage,
					articleTypes: response.articleTypes,
					canCreateArticleType: response.canCreateArticleType,
					canOpenFilters: response.canOpenFilters,
					i18n: response.i18n
				}
			});

		} else if (this.state.download) {//Es download
			this.setState(prevState => {
				return {
					...prevState,
					download: 0
				}
			});

			const newBlob = new Blob([response], { type: 'application/octet-stream' });

			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(newBlob);
			} else {
				// For other browsers: create a link pointing to the ObjectURL containing the blob.
				const objUrl = window.URL.createObjectURL(newBlob);

				let link = document.createElement('a');
				link.href = objUrl;
				link.download = "TiposArticulos.xlsx";
				link.click();

				// For Firefox it is necessary to delay revoking the ObjectURL.
				setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 1000);
			}
		} else if (response.auth === false) {
			this.navigateTo('/login');
		}
	}

	newArticleType() {
		this.navigateTo('/edit_article_type');
	}

	clickPaginationCallback(pageNumber) {
		this.setState(prevState => {
			return {
				...prevState,
				page: pageNumber
			}
		}, this.getArticleTypes);
	}

	deleteClick(event) {

		this.props.setModalContent({
			title: this.getTrad('confirmAction'),
			body: [this.getTrad('doYouWantToDeleteArticleType')],
			buttons: [
				{ shown: 'Aceptar', close: true, behaviour: 'main', callback: this.deleteArticleType.bind(this, event.target.id) },
				{ shown: 'Cancelar', behaviour: 'secondary', close: true }
			]
		});

		$("#exampleModal").modal('toggle');
	}

	deleteArticleType(buttonName) {
		const parts = buttonName.split('_');

		this.setState(prevState => {
			return {
				...prevState,
				deletedArticleType: parts[1]
			}
		});
		const api = this.getApi();
		api.deleteArticleType(parts[1], this.deleteArticleTypeCallback);
	}

	deleteArticleTypeCallback(response) {

		if (response && response.status === 'OK') {

			const articleTypes = this.state.articleTypes.filter(articleType => { return articleType._id !== this.state.deletedArticleType });

			this.setState(prevState => {
				return {
					...prevState,
					articleTypes
				}
			});
			setTimeout(() => {
				this.props.setModalContent({
					title: this.getTrad('messageFromServer'),
					body: [this.getTrad('articleTypeDeletedSuccessfully')],
					buttons: [
						{ shown: 'Cerrar', close: true, behaviour: 'main' }
					]
				});

				$("#exampleModal").modal('toggle');
			}, 500);
		} else {
			setTimeout(() => {
				this.props.setModalContent({
					title: this.getTrad('messageFromServer'),
					body: [this.getTrad(response.message)],
					buttons: [
						{ shown: 'Cerrar', close: true, behaviour: 'main' }
					]
				});

				$("#exampleModal").modal('toggle');
			}, 500);
		}
	}

	showFilters() {
		if (!this.state.canOpenFilters) return false;
		let selectedFilters = {
			dateRange: {
				start: new Date(this.state.startDate),
				end: new Date(this.state.endDate),
			}
		}

		this.props.setSelectedFilters(selectedFilters);
		this.props.setFiltersContent({
			title: 'Edite sus filtros',
			users: this.state.users,
			dates: { start: this.state.startDate, end: this.state.endDate },
			buttons: [
				{ shown: 'Aplicar', close: true, callback: this.filterResults, behaviour: 'main' },
				{ shown: 'Cerrar', close: true }
			]
		});

		$("#filters-component").modal('toggle');
	}

	filterResults() {
		let filters = [];

		for (let prop in this.props.selectedFilters) {
			if (prop === 'users') {
				filters.push({ name: "user_in", value: this.props.selectedFilters[prop].join() })
			}
			if (prop === 'dateRange') {
				filters.push({ name: "sign_date_start", value: this.parseDateToString(this.props.selectedFilters[prop].start) });
				filters.push({ name: "sign_date_end", value: this.parseDateToString(this.props.selectedFilters[prop].end) });
			}
		}

		this.setState(prevState => {
			return {
				...prevState,
				page: 1,
				searchParams: filters
			}
		}, this.getArticleTypes);
	}

	parseDateToString(date) {
		const hoursFromTimezoneOffset = (date.getTimezoneOffset() * -1) / 60;
		let dateToString = new Date(date.getTime());
		dateToString.setHours(date.getHours() + hoursFromTimezoneOffset);

		return dateToString.getUTCFullYear() + "-" +
			("0" + (dateToString.getUTCMonth() + 1)).slice(-2) + "-" +
			("0" + dateToString.getUTCDate()).slice(-2) + " " +
			("0" + dateToString.getUTCHours()).slice(-2) + ":" +
			("0" + dateToString.getUTCMinutes()).slice(-2) + ":" +
			("0" + dateToString.getUTCSeconds()).slice(-2);
	}

	searchCallback(response) {
		//this.props.setUsers(response.users);
		this.setState(prevState => {
			return {
				...prevState,
				articleTypes: response.articleTypes,
				totalItems: response.totalItems,
				totalPages: response.totalPages,
				currentPage: response.currentPage
			}
		});

	}

	render() {
		return (
			<div className="container">
				<Menu />
				<h3>{this.getTrad('ArticleTypesAdmin')}</h3>
				<div className="row mb-2 mt-4">
					<div className="col-4">
						{this.state.canCreateArticleType ? <button type="button" className="btn btn-primary" onClick={this.newArticleType}>
							{this.getTrad('NewArticleType')}
						</button> : ''}
					</div>
					{/*
                    <div className="col-4 text-center">
				<button className="btn btn-secondary" onClick={this.showFilters}>Mostrar filtros</button>
                    </div>
                    */}
					<div className="col-4">
						<button className="btn btn-secondary" onClick={this.excelExport}>Exportar a excel</button>
					</div>
					<div className="col-4 text-right">
						<Seeker
							config={{
								shown: 'name',
								setHandler: this.searchCallback,
								items: this.state.articleTypes,
								handleChangeCallback: this.handleSeekerChange
							}}
						/>

					</div>
				</div>
				<div className="row">
					<div className="col-12">
						<Table
							config={{
								items: this.state.articleTypes,
								i18n: this.state.i18n !== undefined ? this.state.i18n : [],
								mapping: [
									{
										original: 'name', shown: 'Nombre', visible: true, click: {
											url: '/edit_article_type', params: [{ name: 'article_type_id', field: '_id' }]
										}
									},
									{
										original: 'description', shown: this.getTrad('description'), visible: true, click: {
											url: '/edit_article_type', params: [{ name: 'article_type_id', field: '_id' }]
										}
									},
									{ original: '_id', shown: '_id', visible: false },
									{
										original: '_id', button: 'X', shown: 'Eliminar', visible: true, display: 'button',
										prefix: 'deletearticletype_', click_callback: this.deleteClick
									}
								],
								pagination: {
									totalItems: this.state.totalItems ? this.state.totalItems : 0,
									totalPages: this.state.totalPages ? this.state.totalPages : 1,
									currentPage: this.state.currentPage ? this.state.currentPage : 1,
									callback: this.clickPaginationCallback
								}
							}}
						/>
					</div>
				</div>
				<Modal />
				<Filters />
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		selectedFilters: state.selectedFilters
	};
}

const mapDispatchToProps = dispatch => {
	return {
		setModalContent(modalContent) {
			dispatch(setModalContent(modalContent));
		},
		setFiltersContent(filtersContent) {
			dispatch(setFiltersContent(filtersContent));
		},
		setSelectedFilters(selectedFilters) {
			dispatch(setSelectedFilters(selectedFilters));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleTypes)
